import React, { useState, useEffect } from "react";
import axios from "axios";

function CurrencyConverter() {
  const [rate, setRate] = useState(null);
  const [usd, setUsd] = useState("");
  const [cad, setCad] = useState("");

  useEffect(() => {
    const fetchRate = async () => {
      try {
        const response = await axios.get(
          "https://api.frankfurter.app/latest?from=USD&to=CAD",
        );
        setRate(response.data.rates.CAD);
      } catch (error) {
        console.error("Error fetching rate:", error);
      }
    };
    fetchRate();
    if (window.gtag && window.consented)
      window.gtag("event", "tool_view", { tool: "currency" });
  }, []);

  const convertUsdToCad = (value) => {
    if (rate && value) {
      setCad((value * rate).toFixed(2));
    }
  };

  const convertCadToUsd = (value) => {
    if (rate && value) {
      setUsd((value / rate).toFixed(2));
    }
  };

  return (
    <section className="utility canada-theme us-theme">
      <h2>Currency Exchange</h2>
      <p style={{ fontStyle: "italic" }}>
        1 CAD = {rate ? (1 / rate).toFixed(4) : "Loading..."} USD | 1 USD ={" "}
        {rate ? rate.toFixed(4) : "Loading..."} CAD
      </p>
      <div className="conversion-row">
        <div className="left">
          <label>CAD</label>
          <input
            type="number"
            step="0.01"
            value={cad}
            onChange={(e) => {
              setCad(e.target.value);
              convertCadToUsd(e.target.value);
            }}
            className="tall-input"
          />
        </div>
        <div className="right">
          <label>USD</label>
          <input
            type="number"
            step="0.01"
            value={usd}
            onChange={(e) => {
              setUsd(e.target.value);
              convertUsdToCad(e.target.value);
            }}
            className="tall-input"
          />
        </div>
      </div>
    </section>
  );
}

export default CurrencyConverter;
